import { render } from "./homeservices-search.vue?vue&type=template&id=2885e28a"
import script from "./homeservices-search.js?vue&type=script&lang=js"
export * from "./homeservices-search.js?vue&type=script&lang=js"

import "./homeservices-search.vue?vue&type=style&index=0&id=2885e28a&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__